export const warn = (i18n, code, msg, rest) => {
  var _i18n$services, _i18n$services2, _console;
  const args = [msg, {
    code,
    ...(rest || {})
  }];
  if (i18n !== null && i18n !== void 0 && (_i18n$services = i18n.services) !== null && _i18n$services !== void 0 && (_i18n$services = _i18n$services.logger) !== null && _i18n$services !== void 0 && _i18n$services.forward) {
    return i18n.services.logger.forward(args, 'warn', 'react-i18next::', true);
  }
  if (isString(args[0])) args[0] = "react-i18next:: ".concat(args[0]);
  if (i18n !== null && i18n !== void 0 && (_i18n$services2 = i18n.services) !== null && _i18n$services2 !== void 0 && (_i18n$services2 = _i18n$services2.logger) !== null && _i18n$services2 !== void 0 && _i18n$services2.warn) {
    i18n.services.logger.warn(...args);
  } else if ((_console = console) !== null && _console !== void 0 && _console.warn) {
    console.warn(...args);
  }
};
const alreadyWarned = {};
export const warnOnce = (i18n, code, msg, rest) => {
  if (isString(msg) && alreadyWarned[msg]) return;
  if (isString(msg)) alreadyWarned[msg] = new Date();
  warn(i18n, code, msg, rest);
};
const loadedClb = (i18n, cb) => () => {
  if (i18n.isInitialized) {
    cb();
  } else {
    const initialized = () => {
      setTimeout(() => {
        i18n.off('initialized', initialized);
      }, 0);
      cb();
    };
    i18n.on('initialized', initialized);
  }
};
export const loadNamespaces = (i18n, ns, cb) => {
  i18n.loadNamespaces(ns, loadedClb(i18n, cb));
};
export const loadLanguages = (i18n, lng, ns, cb) => {
  if (isString(ns)) ns = [ns];
  if (i18n.options.preload && i18n.options.preload.indexOf(lng) > -1) return loadNamespaces(i18n, ns, cb);
  ns.forEach(n => {
    if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
  });
  i18n.loadLanguages(lng, loadedClb(i18n, cb));
};
export const hasLoadedNamespace = function (ns, i18n) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!i18n.languages || !i18n.languages.length) {
    warnOnce(i18n, 'NO_LANGUAGES', 'i18n.languages were undefined or empty', {
      languages: i18n.languages
    });
    return true;
  }
  return i18n.hasLoadedNamespace(ns, {
    lng: options.lng,
    precheck: (i18nInstance, loadNotPending) => {
      var _options$bindI18n;
      if (((_options$bindI18n = options.bindI18n) === null || _options$bindI18n === void 0 ? void 0 : _options$bindI18n.indexOf('languageChanging')) > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
};
export const getDisplayName = Component => Component.displayName || Component.name || (isString(Component) && Component.length > 0 ? Component : 'Unknown');
export const isString = obj => typeof obj === 'string';
export const isObject = obj => typeof obj === 'object' && obj !== null;